import { Link } from 'react-router-dom'
import {
  CompanyLogo,
  IntegratedAccountPill,
  Tooltip,
  useSEOCountriesJSON
} from '@pepper/ui'
import { ContentRefreshDomain } from '@pepper/utils/src/types/domain'
import { extractDomainName } from '@pepper/utils/src/function/url'

import s from './Item.module.css'

type Props = {
  domain: ContentRefreshDomain
  isGoogleConnected: boolean
  showDomainNameTooltip?: boolean
  shouldRedirectInNewTab: boolean
}

export const Item = ({
  domain,
  isGoogleConnected,
  showDomainNameTooltip = false,
  shouldRedirectInNewTab
}: Props) => {
  const { data: countriesJson } = useSEOCountriesJSON()

  const domainHostName = extractDomainName(domain?.domain_url)

  const _getTooltipText = () => {
    if (
      !domain.ga_property ||
      !domain.gsc_domain_property ||
      !isGoogleConnected
    ) {
      return (
        <>
          {!isGoogleConnected ? 'Google' : !domain.ga_property ? 'GA' : 'GSC'}{' '}
          account is not integrated. You can integrate in&nbsp;
          <Link
            to="/admin-console/domains"
            target={shouldRedirectInNewTab ? '_blank' : '_self'}
            className={s.link}
          >
            settings
          </Link>
        </>
      )
    }
    return null
  }

  return (
    <div className={s.item}>
      <span className={s.domain}>
        <CompanyLogo className={s.companyLogo} companyName={domainHostName} />
        {showDomainNameTooltip ? (
          <Tooltip className={s.domainName} title={domainHostName}>
            {domainHostName}
          </Tooltip>
        ) : (
          <span className={s.domainName}>{domainHostName}</span>
        )}
      </span>

      <span className={s.country}>
        <img
          alt={domain?.country_code}
          className={s.flag}
          src={countriesJson?.[domain?.country_code]?.flag}
          width={20}
        />
        {domain?.country_code}
      </span>

      <Tooltip
        title={_getTooltipText()}
        placement="bottomLeft"
        arrowContent={true}
      >
        <div>
          <IntegratedAccountPill
            isGoogleConnected={isGoogleConnected}
            isIntegrationValid={
              !!domain?.ga_property && !!domain?.gsc_domain_property
            }
          />
        </div>
      </Tooltip>
    </div>
  )
}
